export enum PartnerActionType {
  SetState = 'PARTNER.SET_STATE',
  GET_STATISTIC = 'PARTNER.GET_STATISTIC',
  GET_REFERRAL_LIST = 'PARTNER.GET_REFERRAL_LIST',
  GET_AUTO_BONUS = 'PARTNER.AUTO_BONUS',
}
